export default __webpack_public_path__ + "static/media/publish_invite_active.9bfc0592.svg";